import { EducatorUserService, ServiceStatusEnum } from "@imaginelearning/mps-api-service";
import { getCurrentDateISOString } from "helpers/formatter";
import { useCallback } from "react";
import { useNavigate } from "react-router";

export default function useStudentAuth() {
  const navigate = useNavigate();

  const logStudentIn = useCallback(
    async (accessToken: string, refreshToken: string | undefined) => {
      sessionStorage.setItem("imlpToken", accessToken);
      sessionStorage.setItem("imlpRefreshToken", refreshToken ?? "");

      const apiRequest = {
        ClientDateTime: getCurrentDateISOString(),
        UserAgent: navigator.userAgent
      };
      const result = await EducatorUserService.authenticateUser(apiRequest);
      if (result.status === ServiceStatusEnum.LOADED && result.data.userID > 0) {
        const target = sessionStorage.getItem("target");
        if (target === "MyPath") {
          navigate("/liftoff", { replace: true });
        } else if (target === "I+A") {
          navigate("/assessments", { replace: true });
        }
      }
    },
    [navigate]
  );

  return { logStudentIn };
}
